import { initializeItemReadingPaneInSxS } from '../actions/internalActions';
import { lazyLoadItemReadingPane, getItemReadingPaneViewState } from 'owa-mail-reading-pane-store';
import {
    onSxSReadingPaneChange,
    onBeforeSxSReadingPaneChange,
    SxSReadingPaneMode,
    getOrCreateSxSStoreData,
} from 'owa-sxs-store';
import { orchestrator } from 'satcheljs';

orchestrator(initializeItemReadingPaneInSxS, async actionMessage => {
    const { readingPaneStrategy, instrumentationContext, sxsId } = actionMessage;
    if (!readingPaneStrategy || !readingPaneStrategy.itemId) {
        return;
    }

    const sxsStore = getOrCreateSxSStoreData(sxsId);
    if (
        sxsStore.readingPaneState &&
        sxsStore.readingPaneState.mode === SxSReadingPaneMode.ItemReadingPane &&
        sxsStore.readingPaneState.itemId &&
        sxsStore.readingPaneState.itemId.Id === readingPaneStrategy.itemId.Id
    ) {
        // SxS is already showing the item
        return;
    }

    onBeforeSxSReadingPaneChange(readingPaneStrategy.itemId.Id);
    const itemReadingPaneViewState = getItemReadingPaneViewState();
    if (
        itemReadingPaneViewState &&
        itemReadingPaneViewState.itemId == readingPaneStrategy.itemId.Id
    ) {
        onSxSReadingPaneChange(
            {
                mode: SxSReadingPaneMode.ItemReadingPane,
                itemId: readingPaneStrategy.itemId,
                itemReadingPaneViewState: itemReadingPaneViewState,
            },
            sxsId
        );
    } else {
        const loadItemReadingPane = await lazyLoadItemReadingPane.import();
        await loadItemReadingPane(
            readingPaneStrategy.itemId,
            instrumentationContext,
            itemReadingPaneViewState => {
                onSxSReadingPaneChange(
                    {
                        mode: SxSReadingPaneMode.ItemReadingPane,
                        itemId: readingPaneStrategy.itemId,
                        itemReadingPaneViewState: itemReadingPaneViewState,
                    },
                    sxsId
                );
            }
        );
    }
});
